export default "__VITE_ASSET__Blo1f_um__"